var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.device.id == 71)?_c('Byk',{attrs:{"device":_vm.device}}):_vm._e(),(_vm.device.id == 62)?_c('Buffer',{attrs:{"device":_vm.device}}):_vm._e(),(_vm.device.id == 61)?_c('Fakkel',{attrs:{"device":_vm.device}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }